import React, { useCallback, useState, useEffect } from 'react';
import { Autocomplete } from '@shopify/polaris';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getTranslatedText, Search } from '@nile/components';

function AutoComplete(props) {
  const {
    intl,
    options: allOptions,
    handleAutoCompleteChange,
    handleTextFieldChange,
    uniqueId
  } = props;
  const deselectedOptions = allOptions;
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState(deselectedOptions);

  const updateText = useCallback(
    (value) => {
      setInputValue(value);
      handleTextFieldChange(value);

      if (value === '') {
        setOptions(deselectedOptions);
        return;
      }

      const filterRegex = new RegExp(value, 'i');
      let resultOptions = deselectedOptions.filter((option) =>
        option.label.match(filterRegex)
      );
      resultOptions =
        resultOptions.length === 0
          ? [{ label: 'No Result', value: 'No Result' }]
          : resultOptions;
      setOptions(resultOptions);
    },
    [deselectedOptions]
  );

  function resetField() {
    setSelectedOptions([]);
    setInputValue('');
    handleTextFieldChange('');
    setOptions(allOptions);
  }

  const updateSelection = useCallback((selected) => {
    if (selected[0] === 'No Result') {
      resetField();
      return;
    }
    let selectedOption;
    deselectedOptions.map((option) => {
      if (option.value === selected[0]) {
        selectedOption = option;
      }
    });
    resetField();
    handleAutoCompleteChange(selectedOption);
  }, []);

  const setPortalStyles = () => {
    setTimeout(() => {
      let element = document.getElementById(uniqueId);
      let popoverOverlay =
        element?.parentElement?.parentElement?.parentElement?.parentElement
          ?.parentElement;
      if (popoverOverlay) {
        popoverOverlay.style.zIndex = 500;
      }
    }, 100);
  };

  const textField = (
    <Autocomplete.TextField
      onChange={updateText}
      value={inputValue}
      placeholder={getTranslatedText(
        intl,
        'admin.Holidaymanagement.list.search'
      )}
      onFocus={setPortalStyles}
      prefix={<Search />}
      clearButton
      onClearButtonClick={resetField}
    />
  );

  return (
    <div>
      <Autocomplete
        id={uniqueId}
        options={inputValue.length > 0 ? options : []}
        selected={selectedOptions}
        onSelect={updateSelection}
        textField={textField}
        emptyState={
          <div>
            <p style={{ color: '#666666' }}>
              <FormattedMessage id='admin.search.suggestions' />
            </p>
          </div>
        }
      />
    </div>
  );
}
export default injectIntl(AutoComplete);
